// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shell-module__root--JZLOb {
  box-sizing: border-box;
}

.Shell-module__ui-Shell--eYWTI {
  display: flex;
  align-items: center;
  width: 100%;
}

.Shell-module__ui-Shell-Leading--vmele {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-right: 9px;
}

.Shell-module__ui-Shell-Content--OtcP9 {
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  min-height: 44px;
  gap: 3px;
  white-space: pre-wrap;
}

.Shell-module__ui-Shell--eYWTI.Shell-module__vertical-align-top--lMsRJ {
  align-items: flex-start;
}

.Shell-module__ui-Shell--eYWTI.Shell-module__vertical-align-center--Fz_kM {
  align-items: center;
}

.Shell-module__ui-Shell--eYWTI.Shell-module__vertical-align-bottom--ddvDn {
  align-items: flex-end;
}

.Shell-module__ui-Shell-Content--OtcP9.Shell-module__vertical-align-top--lMsRJ {
  justify-content: flex-start;
}

.Shell-module__ui-Shell-Content--OtcP9.Shell-module__vertical-align-center--Fz_kM {
  justify-content: center;
}

.Shell-module__ui-Shell-Content--OtcP9.Shell-module__vertical-align-bottom--ddvDn {
  justify-content: flex-end;
}

.Shell-module__title--jApFl {
  padding-bottom: 2px;
  color: #000;
  font-size: 0.875rem; /* 14px */
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
}

.Shell-module__content--kNWmB {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;

  width: 100%;
}

.Shell-module__ui-Shell-Trailing--Igc8U {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: right;
}
.Shell-module__is-reverse--yj6hN {
  color: #ffffff;
}

.Shell-module__is-reverse--yj6hN .Shell-module__title--jApFl {
  color: #ffffff;
}

.Shell-module__is-reverse--yj6hN .Shell-module__content--kNWmB {
  color: #999999;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Shell/Shell.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".root {\n  box-sizing: border-box;\n}\n\n.ui-Shell {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.ui-Shell-Leading {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding-right: 9px;\n}\n\n.ui-Shell-Content {\n  display: flex;\n  flex: 1 0 0;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n  min-height: 44px;\n  gap: 3px;\n  white-space: pre-wrap;\n}\n\n.ui-Shell.vertical-align-top {\n  align-items: flex-start;\n}\n\n.ui-Shell.vertical-align-center {\n  align-items: center;\n}\n\n.ui-Shell.vertical-align-bottom {\n  align-items: flex-end;\n}\n\n.ui-Shell-Content.vertical-align-top {\n  justify-content: flex-start;\n}\n\n.ui-Shell-Content.vertical-align-center {\n  justify-content: center;\n}\n\n.ui-Shell-Content.vertical-align-bottom {\n  justify-content: flex-end;\n}\n\n.title {\n  padding-bottom: 2px;\n  color: #000;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 600;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #666;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: normal;\n  white-space: nowrap;\n\n  width: 100%;\n}\n\n.ui-Shell-Trailing {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: right;\n}\n.is-reverse {\n  color: #ffffff;\n}\n\n.is-reverse .title {\n  color: #ffffff;\n}\n\n.is-reverse .content {\n  color: #999999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Shell-module__root--JZLOb`,
	"ui-Shell": `Shell-module__ui-Shell--eYWTI`,
	"ui-Shell-Leading": `Shell-module__ui-Shell-Leading--vmele`,
	"ui-Shell-Content": `Shell-module__ui-Shell-Content--OtcP9`,
	"vertical-align-top": `Shell-module__vertical-align-top--lMsRJ`,
	"vertical-align-center": `Shell-module__vertical-align-center--Fz_kM`,
	"vertical-align-bottom": `Shell-module__vertical-align-bottom--ddvDn`,
	"title": `Shell-module__title--jApFl`,
	"content": `Shell-module__content--kNWmB`,
	"ui-Shell-Trailing": `Shell-module__ui-Shell-Trailing--Igc8U`,
	"is-reverse": `Shell-module__is-reverse--yj6hN`
};
export default ___CSS_LOADER_EXPORT___;
